export default {
  methods: {
    getSwatchMaterialTemplate({ swatchObj }) {
      if (!swatchObj || !swatchObj.material_template) return Promise.resolve();
      return this.$store.dispatch("swatchMaterialGroups/GET_MATERIALS_BY_NAME", { materialName:  swatchObj.material_template});
    }
  }
};